<p-confirmDialog
  #cd
  [breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
  [style]="{ width: '30vw' }"
  acceptLabel="{{ 'Si' | translate }}"
  rejectLabel="{{ 'No' | translate }}"
  rejectButtonStyleClass="p-button-text"
>
</p-confirmDialog>
